'use strict';

module.exports = {
	learnToCode: {
		label: 'Learning to code'
	},

	makeGames: {
		label: 'Making games'
	},

	playWithFriends: {
		label: 'Playing with friends'
	}
};
